// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__vmrgp","rootSmall":"AddTileButton_rootSmall__1rNge"};